import AssetsClient from '@locuslabs/assets-client';
import * as Request from '../request';
import * as Config from '../config';

const assetsClient = async (stage = Config.getStage()) => {
    const accessToken = await Config.getAccessToken();
    return AssetsClient(accessToken, stage);
};

const getStatusRequest = Request.makeRequest(assetsClient, 'status');
const publishRequest = Request.makeRequest(assetsClient, 'publish');

const Assets = {
    getPublishStatus: (venueId, opts) => getStatusRequest(venueId, opts),
    publish: venueId => publishRequest(venueId),
};

export { Assets };
